import { Modal, Text, InlineStack } from '@shopify/polaris';

const ConfirmActiveVouchersModal = ({ open, onClose, onConfirm, duplicateEmails = [], activeEmails = [] }) => {
    const displayItemLimit = 10;
    // Below we are preparing data for display in the modal
    // the goal is to differentiate betwen duplicates and active vouchers

    // Calculate counts
    const totalDuplicateCount = Array.isArray(duplicateEmails) ? duplicateEmails.length : 0;
    const totalActiveCount = Array.isArray(activeEmails) ? activeEmails.length : 0;

    // Prepare lists to show with "+X more" if needed
    const duplicateEmailsToShow = (duplicateEmails || []).slice(0, displayItemLimit);
    const duplicateEmailsExtraCount = Math.max(0, totalDuplicateCount - duplicateEmailsToShow.length);

    // Same for active emails
    const activeEmailsToShow = (activeEmails || []).slice(0, displayItemLimit);
    const activeEmailsExtraCount = Math.max(0, totalActiveCount - activeEmailsToShow.length);

    // Title strictly based on the new buckets
    let modalTitle = 'Warning: Issues detected';
    if (totalDuplicateCount > 0 && totalActiveCount === 0) {
        modalTitle = 'Warning: Duplicate emails found';
    } else if (totalDuplicateCount === 0 && totalActiveCount > 0) {
        modalTitle = 'Warning: Active vouchers found';
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={modalTitle}
            primaryAction={{
                content: 'Proceed anyway',
                onAction: onConfirm,
                destructive: true,
            }}
            secondaryActions={[{ content: 'Cancel', onAction: onClose }]}
        >
            <Modal.Section>
                {totalDuplicateCount > 0 && (
                    <Text as="p">
                        We found {totalDuplicateCount} duplicate email
                        {totalDuplicateCount === 1 ? '' : 's'} in your CSV upload.
                    </Text>
                )}

                {totalActiveCount > 0 && (
                    <Text as="p">
                        We found {totalActiveCount} email
                        {totalActiveCount === 1 ? '' : 's'} that already {totalActiveCount === 1 ? 'has' : 'have'} an <strong>active</strong> voucher in this program.
                    </Text>
                )}

                {duplicateEmailsToShow.length > 0 && (
                    <>
                        <Text as="p" variant="bodySm" tone="subdued" style={{ marginTop: 8 }}>
                            Duplicate emails in CSV:
                        </Text>
                        <ul style={{ marginTop: 4, paddingLeft: 18 }}>
                            {duplicateEmailsToShow.map((emailAddress) => (
                                <li key={`duplicate-${emailAddress}`}>
                                    <Text as="span">{emailAddress}</Text>
                                </li>
                            ))}
                            {duplicateEmailsExtraCount > 0 && (
                                <li>
                                    <Text as="span">+{duplicateEmailsExtraCount} more…</Text>
                                </li>
                            )}
                        </ul>
                    </>
                )}

                {activeEmailsToShow.length > 0 && (
                    <>
                        <Text as="p" variant="bodySm" tone="subdued" style={{ marginTop: 12 }}>
                            Emails with active vouchers:
                        </Text>
                        <ul style={{ marginTop: 4, paddingLeft: 18 }}>
                            {activeEmailsToShow.map((emailAddress) => (
                                <li key={`active-${emailAddress}`}>
                                    <Text as="span">{emailAddress}</Text>
                                </li>
                            ))}
                            {activeEmailsExtraCount > 0 && (
                                <li>
                                    <Text as="span">+{activeEmailsExtraCount} more…</Text>
                                </li>
                            )}
                        </ul>
                    </>
                )}

                <InlineStack gap="200" align="start" style={{ marginTop: 12 }}>
                    <Text as="p" tone="subdued">
                        Proceeding will still create/send vouchers for these recipients.
                    </Text>
                </InlineStack>
            </Modal.Section>
        </Modal>
    );
};

export default ConfirmActiveVouchersModal;
